import './index.scss';
import Grid from '@mui/material/Grid';
import { FunctionComponent } from 'react';
import BrowserIcon from 'src/assets/icons/chrome-icon.png';
import { List, ListItem, ListItemText, Typography } from '@mui/material';

const IncompatibleView: FunctionComponent = () => {
  const redirectClick = (): void => {
    const url = 'https://play.google.com/store/search?q=chrome&c=apps';

    window.open(url, '_blank', 'noreferrer');
  };

  const renderSteps = (): JSX.Element => {
    return (
      <>
        <List>
          <Typography gutterBottom>
            ¡Optimiza tu experiencia de navegación para tu preinspección
            configurando Google Chrome como tu navegador por defecto!
          </Typography>
          <br />
          <Typography gutterBottom>Sigue estos simples pasos:</Typography>
          <>
            <ListItem>
              <ListItemText
                primary="1. Abre la Configuración:"
                secondary={
                  <Typography className="li-text-custom">
                    Desliza hacia abajo desde la parte superior de la pantalla
                    para acceder al menú de notificaciones y toca el ícono de{' '}
                    <b>Configuración</b>.
                  </Typography>
                }
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="2. Selecciona Aplicaciones:"
                secondary={
                  <Typography className="li-text-custom">
                    En la sección <b>Dispositivo</b>, busca y selecciona{' '}
                    <b>Aplicaciones</b> o <b>Aplicaciones y notificaciones</b>,
                    según la versión de Android que estés utilizando.
                  </Typography>
                }
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="3. Administrar Aplicaciones:"
                secondary={
                  <Typography className="li-text-custom">
                    En la lista de aplicaciones, busca y selecciona{' '}
                    <b>Aplicaciones predeterminadas</b> o{' '}
                    <b>Todas las aplicaciones</b>.
                  </Typography>
                }
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="4. Elige Navegador:"
                secondary={
                  <Typography className="li-text-custom">
                    Encuentra la categoría de <b>Navegador</b> o{' '}
                    <b>Navegador predeterminado</b>. Luego, selecciona la
                    aplicación que actualmente está configurada como navegador
                    por defecto.
                  </Typography>
                }
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="5. Selecciona Google Chrome:"
                secondary={
                  <Typography className="li-text-custom">
                    Selecciona &rsquo;Google Chrome&rsquo; de la lista de
                    navegadores disponibles. Si Chrome no aparece en la lista,
                    asegúrate de tenerlo instalado desde la tienda de
                    aplicaciones de{' '}
                    <a
                      className="app-link"
                      rel="noopener noreferrer"
                      onClick={redirectClick}
                    >
                      Google Play
                    </a>
                    .
                  </Typography>
                }
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="6. Confirma tu Elección:"
                secondary={
                  <Typography className="li-text-custom">
                    Te llevará a una pantalla de confirmación. Toca{' '}
                    <b>Aceptar</b> o <b>Establecer como predeterminado</b> para
                    confirmar que deseas usar Google Chrome como tu navegador
                    por defecto.
                  </Typography>
                }
              />
            </ListItem>
          </>
        </List>
      </>
    );
  };

  return (
    <>
      <div className="incompatible-view">
        <Grid container spacing={2}>
          <Grid xs={2}></Grid>
          <Grid xs={8} className="incompatible-view__bodyMsg">
            <img id="browser-icon" src={BrowserIcon} alt="Browser" />
            {renderSteps()}
            <p id="foot-signed">
              {' '}
              Powered by <span>Connect Assistance</span>
            </p>
          </Grid>
          <Grid xs={2}></Grid>
        </Grid>
      </div>
    </>
  );
};

export default IncompatibleView;
